import { render, staticRenderFns } from "./ecollectioninquiry.vue?vue&type=template&id=11551e7e&"
import script from "./ecollectioninquiry.vue?vue&type=script&lang=js&"
export * from "./ecollectioninquiry.vue?vue&type=script&lang=js&"
import style0 from "./ecollectioninquiry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports